import { node } from 'prop-types';
import { Navigate, useLocation } from 'react-router-dom';

import { useUser } from 'hooks';
import { routes } from 'router';
import { envService } from 'services';

const ProtectedRoute = ({ children }) => {
  const location = useLocation();
  const { isLoggedIn } = useUser();

  const isMaintenance = process.env.REACT_APP_SHOW_MAINTENANCE_PAGE === 'true';
  const isAuthPath = [
    routes.login.path,
    routes.forgotPassword.path,
    routes.registration.path,
    routes.updatePassword.path
  ].includes(location.pathname);
  const isDesignSystemPath = location.pathname === routes.designSystem.path;
  const showDesignSystem = envService.isRunningInDev() || envService.isRunningInStaging();
  const isInvalidSsoPath = location.pathname === routes.sso.path && !location.search.includes('return_to');

  // Redirect to maintenance page if maintenance is enabled, and block access to all other pages
  if (isMaintenance) return <Navigate to={routes.maintenance.path} state={{ from: location }} replace />;

  /* Prevent access to auth page if user is already logged in,
    or if user tries to access invalid sso page (without return_to query param)
    and redirect to home page
  */
  if (isLoggedIn && (isAuthPath || isInvalidSsoPath)) {
    return <Navigate to={routes.home.path} state={{ from: location }} replace />;
  }

  if (isDesignSystemPath && !showDesignSystem) {
    return <Navigate to={routes.home.path} state={{ from: location }} replace />;
  }

  // Redirect to login page if user is not logged in, and block access to all other pages
  if (!isAuthPath && !isDesignSystemPath && !isLoggedIn)
    return (
      <Navigate
        to={routes.login.path}
        state={{
          from: {
            pathname: location.pathname,
            search: location.search
          }
        }}
        replace
      />
    );

  // Grant access to routes to authorized users
  return children;
};

ProtectedRoute.propTypes = {
  children: node
};

export default ProtectedRoute;
